import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function querySort(){
  return request({
    url:applicationName+'/web/corporateImage/sort',
    method:'get',
  })
}

export function queryList(data){
  return request({
    url:applicationName+'/web/corporateImage/list',
    method:'get',
    params:data
  })
}

export function addNum(data){
  return request({
    url:applicationName+'/web/corporateImage/num',
    method:'put',
    params:data
  })
}

